import locale from "localization/en";

export const purchaseOrderColumn = [
  { key: "orderId", text: locale.orderId },
  {
    key: "purchaseOrderNo",
    text: locale.purchaseOrderNo,
    style: {
      width: "auto",
      minWidth: "150px",
    },
  },
  {
    key: "salesOrderNo",
    text: locale.salesOrderNo,
    style: {
      width: "auto",
      minWidth: "150px",
    },
  },
  {
    key: "orderDateAndTime",
    text: locale.orderDateAndTime,
    style: {
      width: "auto",
      minWidth: "150px",
    },
  },
  { key: "products", text: locale.products },
  { key: "amountInKL", text: locale.amountInKL, width: "150px" },
  { key: "amountInPhp", text: locale.amountInPhp },
  { key: "status", text: locale.status },
  { key: "action", text: locale.action },
];
